<template>
  <div class="iw">
    <div v-if="loading && !events" class="iw-skeleton"></div>
    <p v-else-if="!events || !events.length" class="ov-empty">{{ $t('dash.overview.alerts.inbox_empty') }}</p>
    <ul v-else class="iw-list">
      <li v-for="ev in events" :key="ev.key" class="iw-row" @click="$emit('open-inbox-event', ev)">
        <span class="iw-date">{{ ev.timestamp ? formatDate(ev.timestamp) : '' }}</span>
        <span class="iw-main">
          <span class="iw-title"><span class="iw-type" :class="`iw-type--${typeFamily(ev.raw_type)}`">{{ ev.type }}</span> {{ ev.author }}</span>
          <small>{{ ev.text || '—' }}</small>
          <small v-if="ev.page" class="iw-page">{{ ev.page.name }}</small>
        </span>
        <i class="material-icons iw-open">open_in_browser</i>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment'

/**
 * Derniers événements Inbox en attente des pages du tableau de bord (mêmes couleurs que « À traiter »)
 */
export default {
  name: 'InboxWidget',

  props: {
    events: { type: Array, default: null },
    loading: { type: Boolean, default: false }
  },

  created() {
    this.$emit('load-inbox')
  },

  methods: {
    typeFamily(type) {
      if (['status', 'photo', 'video', 'share', 'post'].includes(type)) return 'post'
      if (type === 'message-reaction') return 'reaction'
      return ['comment', 'mention', 'rating', 'message', 'reaction'].includes(type) ? type : 'default'
    },

    formatDate(date) {
      return moment(date).format('DD/MM HH:mm')
    }
  }
}
</script>

<style scoped>
.iw {
  height: 100%;
  min-height: 0;
}
.iw-skeleton {
  height: 100%;
  border-radius: 6px;
  background: #f1edf5;
}
.iw-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.iw-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.iw-row:hover {
  background: #f6f1fa;
}
.iw-date {
  flex: 0 0 auto;
  width: 70px;
  font-size: 11px;
  color: #9ba3b7;
}
.iw-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.iw-title {
  font-size: 12.5px;
  font-weight: 600;
  color: #121826;
}
.iw-main small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11.5px;
  color: #555e75;
}
.iw-main .iw-page {
  color: #9ba3b7;
}
.iw-open {
  font-size: 16px;
  color: #ab6e93;
}
.iw-type {
  display: inline-block;
  margin-right: 4px;
  padding: 0 7px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  background: #f1edf5;
  color: #6b1f4d;
}
.iw-type--comment { background: #dbeafe; color: #1e40af; }
.iw-type--mention { background: #ede9fe; color: #5b21b6; }
.iw-type--rating { background: #fef9c3; color: #854d0e; }
.iw-type--message { background: #dcfce7; color: #166534; }
.iw-type--reaction { background: #fce7f3; color: #9d174d; }
.iw-type--post { background: #cffafe; color: #164e63; }
</style>
